export default {
    apiKey: "AIzaSyArLvtnL1aPutOKiFN7n9OZwNXiHko_N0E",
    authDomain: "no-expiry-e8e4c.firebaseapp.com",
    databaseURL: "https://no-expiry-e8e4c.firebaseio.com",
    projectId: "no-expiry-e8e4c",
    storageBucket: "no-expiry-e8e4c.appspot.com",
    messagingSenderId: "335749170418",
    appId: "1:335749170418:web:49fc6e39ec3d4925c0fc6b",
    measurementId: "G-0L0Z3YFZZ3"
}